import { render, staticRenderFns } from "./ownerDiningList.vue?vue&type=template&id=0a3943d3&scoped=true"
import script from "./ownerDiningList.vue?vue&type=script&lang=js"
export * from "./ownerDiningList.vue?vue&type=script&lang=js"
import style0 from "./ownerDiningList.vue?vue&type=style&index=0&id=0a3943d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3943d3",
  null
  
)

export default component.exports